export const PORT_STATE = {
  PREVIOUS: 'previous',
  CURRENT: 'current',
  NEXT: 'next',
} as const;

export const PORT_TYPE = {
  LOADING: 'L',
  DISCHARGING: 'D',
  BUNKERING: 'F',
  TRANSIT: 'T',
} as const;

export const PORT_ACTION = {
  EST_DEPARTURE: 'est_departure',
  EST_ARRIVAL: 'est_arrival',
  EST_BERTH: 'est_berth',
  DEPARTURE: 'departure',
} as const;

export const PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE = {
  BUNKER_STEM: 'bunkerStem',
  LOAD_CARGO: 'loading',
  DISCHARGE_CARGO: 'discharging',
} as const;

export const PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE = {
  TRANSIT: 'transit',
  DISCHARGE: 'discharge',
  LOAD: 'load',
} as const;

export const PORT_CALLS_CARGO_TERMS_TYPES = {
  LINEAR: 'LINEAR',
  FREE_IN_OUT: 'FREE_IN_OUT',
} as const;

export const PORT_CALLS_DOCUMENT_TYPES = {
  BOL: 'bol',
  SOF: 'sof',
  NOR: 'nor',
  MATES: 'mates',
} as const;

export const PORT_CALLS_CARGO_TYPE_TO_TEXT = {
  [PORT_TYPE.LOADING]: 'Load',
  [PORT_TYPE.DISCHARGING]: 'Discharge',
  [PORT_TYPE.TRANSIT]: 'Transit',
} as const;

export const FUEL_TYPE = {
  VLSFO: 'vlsfo',
  LSMGO: 'lsmgo',
  BIO_VLSFO: 'bio_vlsfo',
  BIO_LSMGO: 'bio_lsmgo',
} as const;

export const PORT_CALLS_ACTIVITY_WIDGET_TYPES = [
  PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.BUNKER_STEM,
  PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.LOAD_CARGO,
  PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.DISCHARGE_CARGO,
] as const;

export const PORT_CALLS_ACTIVITY_WIDGET_TYPES_TO_TITLE = {
  [PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.BUNKER_STEM]: 'Bunker Stem',
  [PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.LOAD_CARGO]: 'Load Cargo',
  [PORT_CALLS_DETAILS_ACTIVITY_WIDGET_TYPE.DISCHARGE_CARGO]: 'Discharge Cargo',
} as const;

export const PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPES_TO_TITLE = {
  [PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.TRANSIT]: 'Transit Cargo',
  [PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.DISCHARGE]: 'Discharge Cargo',
  [PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.LOAD]: 'Load Cargo',
} as const;

export const PORT_CALLS_CARGO_WIDGET_TYPES = [
  PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.TRANSIT,
  PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.LOAD,
  PORT_CALLS_CARGO_ACTIVITY_WIDGET_TYPE.DISCHARGE,
] as const;

export const PORT_CALLS_OVERVIEW_WIDGET_TYPE = {
  STATUS: 'status',
  VESSEL: 'vessel',
  VOYAGE: 'voyage',
  QTY_ON_BOARD: 'qtyOnBoard',
  TOTAL_PORT_DAYS: 'totalPortDays',
  TRADE: 'trade',
  FUELING: 'fueling',
} as const;

export const PORT_CALLS_OVERVIEW_WIDGET_TYPES = [
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.STATUS,
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.VESSEL,
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.VOYAGE,
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.QTY_ON_BOARD,
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.TOTAL_PORT_DAYS,
  PORT_CALLS_OVERVIEW_WIDGET_TYPE.TRADE,
] as const;

export const PORT_CALLS_OVERVIEW_WIDGET_TYPES_TO_TITLE = {
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.STATUS]: 'Voyage Status',
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.VESSEL]: 'Vessel',
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.VOYAGE]: 'Voyage',
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.QTY_ON_BOARD]: 'Qty on Board',
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.TOTAL_PORT_DAYS]: 'Total Port Days',
  [PORT_CALLS_OVERVIEW_WIDGET_TYPE.TRADE]: 'Trade',
} as const;

export const FUEL_TYPE_TITLES = {
  [FUEL_TYPE.VLSFO]: 'VLSFO',
  [FUEL_TYPE.LSMGO]: 'LSMGO',
  [FUEL_TYPE.BIO_VLSFO]: 'Bio VLSFO',
  [FUEL_TYPE.BIO_LSMGO]: 'Bio LSMGO',
} as const;
